/**
 * Defines how an animation should be played by the AnimationManager.
 * This enum matches the C++ AnimationPlayStyle from tabanim.
 */
export enum AnimationPlayStyle {
  /**
   * Animation plays once from start to finish, then stops.
   * This is the most common play style for UI animations.
   */
  OneShot = 'OneShot',

  /**
   * Animation loops continuously, restarting from the beginning
   * after reaching the end.
   */
  Loop = 'Loop',

  /**
   * Animation rocks back and forth, playing forward then backward
   * repeatedly.
   */
  Rocker = 'Rocker',

  /**
   * Interactive animation controlled by user input.
   * The animation fraction is set directly rather than
   * being driven by time.
   */
  Interactive = 'Interactive',
}
